import Banner from "./section/banner";
import Vision from "./section/vision";
import Feature from "./section/feature";
import Master from "./section/master";
import EligibilityCheckBlock from "./section/EligibilityCheckBlock";
import UpcomingBatches from "./section/UpcomingBatches";

const HomeFour = () => {
  return (
    <>
      <Banner />
      <EligibilityCheckBlock />
      <Vision />
      <Feature />
      <Master />
      {/* <Featureinstructors /> */}
    </>
  );
};

export default HomeFour;
